import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '@marty-js/design/src/utils/mq';

export const AdWrapper = styled.div`
  margin: 15px -20px 30px;
  max-width: 100vw;

  &.mod-desktop-only {
    ${mq.lte(
      DEVICE_SIZE.LARGE,
      css`
        display: none;
      `,
    )}
  }

  ${mq.gte(
    DEVICE_SIZE.LARGE,
    css`
      margin: 15px 0 60px;
      max-width: initial;

      &.mod-mobile-only {
        display: none;
      }
    `,
  )}
`;
